
import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { CookiesPolicyComponent } from './cookies-policy/cookies-policy.component';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-cookies-banner',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
    ],
    templateUrl: './cookies-banner.component.html',
    styleUrls: ['./cookies-banner.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    animations: [
        trigger('fadeSlide', [
            transition(':enter', [
                style({ transform: 'translateY(120px)', backgroundColor: 'transparent' }),
                animate('500ms cubic-bezier(0.22, 1, 0.36, 1)',
                    style({ transform: 'translateY(0)', backgroundColor: 'transparent' }))
            ]),
            transition(':leave', [
                animate('250ms cubic-bezier(0.4, 0, 0.2, 1)',
                    style({ opacity: 0, transform: 'translateY(16px)', backgroundColor: 'transparent' }))
            ])
        ])
    ],
})

export class CookiesBannerComponent {
    private cookieService: CookieService = inject(CookieService);
    private modalController: ModalController = inject(ModalController);

    private showCookiesModal = signal<boolean>(false);
    private cookiesModal: any;

    public showCookies = signal<boolean>(false);

    ngAfterViewInit(){
        const cookiesViewed = this.cookieService.get('cookies-policy');
        if (!cookiesViewed)
            setTimeout(() => { this.showCookies.set(true) }, 7500);
    }

    async goToCookiesPolicy(){
        if (this.showCookiesModal()){
            this.cookiesModal.dismiss();
            return;
        }

       this.showCookiesModal.set(true);
       this.cookiesModal = await this.modalController.create({
            component: CookiesPolicyComponent,
            cssClass: "pdfModal",
        });
        await this.cookiesModal.present();
        await this.cookiesModal.onDidDismiss();
        this.showCookiesModal.set(false);
    }

    acceptCookies(){
        this.showCookies.set(false);
        this.cookieService.set('cookies-policy', 'accepted');
    }
    
}